import FaqAnswerUndelivered from "../../../../src/components/faqAnswerUndelivered";
import * as React from 'react';
export default {
  FaqAnswerUndelivered,
  React
};